import type { GrpcClient } from '@pushwoosh/http-client';
import { GPT3ServiceClient } from '@pushwoosh/gpt3-service-client/pushwoosh/Gpt3clientServiceClientPb';
import { CreateByKeywordsRequest } from '@pushwoosh/gpt3-service-client/pushwoosh/gpt3client_pb';


export type Gpt3GrpcBridge = {
  createByKeywords: (params: { keywords: string }) => Promise<{ content: string }>;
}

export function createGpt3GrpcBridge(grpcClient: GrpcClient): Gpt3GrpcBridge {
  const client = grpcClient.createServiceClient(GPT3ServiceClient);
  return {
    createByKeywords: async (params) => {
      const req = new CreateByKeywordsRequest()
        .setKeywords(params.keywords);
      const res = await client.createByKeywords(req, null);
      return { content: res.getText() };
    },
  };
}
